import { createApp } from 'vue'
import pinia from './stores/store'
import router from './router/index'
import App from './App.vue'

import { createVuetify } from 'vuetify'
import * as directives from 'vuetify/directives'
import { fa } from "vuetify/iconsets/fa";
import { aliases, mdi } from "vuetify/iconsets/mdi";

import "@mdi/font/css/materialdesignicons.css";


import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import fr from './locales/fr.json'
type MessageSchema = typeof en

export const i18n = createI18n<[MessageSchema], 'fr' | 'en'>({
    locale: 'fr',    
    messages: {
        fr: fr,
        en: en,
    },
})

const vuetify = createVuetify(
    {  
        theme: {
            defaultTheme: "light",
          },
          icons: {
            defaultSet: "mdi",
            aliases,
            sets: {
              mdi,
              fa,
            },
          },
        //components,
        directives 
    })

const app = createApp(App)

app.config.globalProperties.window = window
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vuetify)
app.mount('#app')
console.log('started!')